export type {
  DataMasking,
  FragmentType,
  Masked,
  MaskedDocumentNode,
  MaybeMasked,
  Unmasked,
} from "./types.js";
export { disableWarningsSlot } from "./utils.js";
export { maskFragment } from "./maskFragment.js";
export { maskOperation } from "./maskOperation.js";
